import style from './express-workout-home-card-list.module.scss'
import React from 'react'
import { WorkoutCardSkeleton } from 'src/component/ui/workout-card/workout-card-skeleton'

interface ExpressWorkoutHomeCardSkeletonProps {
  isLarge?: boolean
}

export const ExpressWorkoutHomeCardSkeleton = ({ isLarge = false }: ExpressWorkoutHomeCardSkeletonProps): React.ReactElement => {
  return (
    <div className={isLarge ? style.largeCardWrapper : undefined}>
      <WorkoutCardSkeleton
        className={`${style.workoutCard} ${isLarge ? style.largeCard : style.smallCard} ${
          isLarge ? style.largeCardWrapper : undefined
        }`}
        aspectRatio={`aspect-[16/9] ${isLarge ? 'md:aspect-[16/9]' : 'md:aspect-auto'}`}
      />
    </div>
  )
}
